module.exports = __webpack_public_path__ + "static/media/info.d36b2ed6.png";